"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpDefinitionViewFields = void 0;
const BasicFieldType_1 = __importDefault(require("@opsbase/lib-data-fieldtype/BasicFieldType"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const ViewFieldKey_1 = __importDefault(require("../ViewFieldKey"));
exports.OpDefinitionViewFields = {
    [ViewFieldKey_1.default.OPDEFINITION_FEATURES]: {
        key: ViewFieldKey_1.default.OPDEFINITION_FEATURES,
        fieldType: BasicFieldType_1.default.OPDEF_FEATURES,
        label: () => lib_i18n_1.default.t('features'),
        description: () => lib_i18n_1.default.t('features-description'),
        sortable: false,
        width: 160,
        gqlFields: 'permitAdhoc, isScoreEnabled, scheduled',
    },
    [ViewFieldKey_1.default.OPDEFINITION_WHERE]: {
        key: ViewFieldKey_1.default.OPDEFINITION_WHERE,
        fieldType: BasicFieldType_1.default.OPDEF_WHERE,
        label: () => lib_i18n_1.default.t('where'),
        allLabel: () => '- - -',
        emptyLabel: () => '- - -',
        description: () => lib_i18n_1.default.t('where-description'),
        sortable: false,
        width: 150,
        gqlFields: 'placeTags, placesSelectedByTag, placesSelectedByParent, places { id, title, timezone }',
    },
    [ViewFieldKey_1.default.OPDEFINITION_WHO]: {
        key: ViewFieldKey_1.default.OPDEFINITION_WHO,
        fieldType: BasicFieldType_1.default.OPDEF_WHO,
        label: () => lib_i18n_1.default.t('who'),
        description: () => lib_i18n_1.default.t('who-description'),
        sortable: false,
        width: 150,
        gqlFields: 'positions { id, title }, teams { id, title }, allPTsPermitted',
    },
    [ViewFieldKey_1.default.OPDEFINITION_ENABLED]: {
        key: ViewFieldKey_1.default.OPDEFINITION_ENABLED,
        fieldType: BasicFieldType_1.default.OPDEF_ENABLED,
        propertyName: 'enabled',
        label: () => lib_i18n_1.default.t('enabled'),
        description: () => lib_i18n_1.default.t('enabled-description'),
        sortable: false,
        width: 100,
        gqlFields: 'enabled, lockEditingToPrimaryAdmins, lockEditing, editorStaff { id }',
    },
    [ViewFieldKey_1.default.OPDEFINITION_PUBLISHED]: {
        key: ViewFieldKey_1.default.OPDEFINITION_PUBLISHED,
        fieldType: BasicFieldType_1.default.OPDEF_PUBLISHED,
        label: () => lib_i18n_1.default.t('published'),
        description: () => lib_i18n_1.default.t('published-description'),
        sortable: false,
        width: 160,
        gqlFields: 'lastPublishedDate, requiresPublishing, form, formConstraints',
    },
};
exports.default = exports.OpDefinitionViewFields;
